import styled from '@emotion/styled'

export const DeleteWrapper = styled.div`
  display: inline-block;
  margin: 15px 0;
`
